
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@mui/material/styles';
import {
    Container,
    Box,
} from '@mui/material';
import { Switch } from 'src/@/components/ui/switch';

import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';

// zui
import { Button } from 'src/@/components/ui/button';
import { RowInput } from 'src/components/forms/RowInput';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import actionListaIntegracoesByCliente from 'src/actions/clientes/actionListaIntegracoesByCliente';
import actionEditarIntegracao from 'src/actions/clientes/actionEditarIntegracao';
import GoogleLogin from './components/GoogleLogin';
import { GoogleOAuthProvider } from '@react-oauth/google';


export default function Google() {
    const { cliente } = useAuth()
    const navigate = useNavigate();
    const [id, setId] = useState(null);
    const [chatGptStatus, setChatGptStatus] = useState(false)
    const [instrucaoChatgpt, setInstrucaoChatgpt] = useState('');
    const enqueueSnackbar = useSnackbar();


    const buscarListaIntegracoesByCliente = async () => {
        try {
            const response = await actionListaIntegracoesByCliente(cliente._id);

            if (response.data && response.data.data.length > 0) {
                if (response.data.data.some(item => item.resource === "chatgpt")) {
                    let dadosFiltrados = response.data.data.filter(item => item.resource === "chatgpt")[0];
                    setInstrucaoChatgpt(dadosFiltrados.config.instrucao)
                    setChatGptStatus(dadosFiltrados.status)
                    setId(dadosFiltrados._id)
                }
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const editarConfigChatGpt = async () => {
        try {
            let data = {
                scope: {
                    clienteId: cliente._id,
                    status: chatGptStatus,
                    intrucao: instrucaoChatgpt
                },
                action: "editar_chatgpt",
            }
            await actionEditarIntegracao(id, data);
            enqueueSnackbar('Configuração salva com sucesso', { variant: 'success' });
            buscarListaIntegracoesByCliente();

        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        buscarListaIntegracoesByCliente()
        return () => {
            setChatGptStatus(null);
            setInstrucaoChatgpt('');
            setId(null);
        }
    }, [])





    return (
        <Box>


            <Container sx={{ mt: 4 }} maxWidth="lg">
                <HeaderPageComponentConfig
                    backAction={() => navigate('/dashboard/configuracoes/integracoes')}
                    titulo="Google"
                    descricao={'O recurso Usuários contém todos os agentes que sua empresa está envolvida. É possível editar contatos e senhas de acesso.'}
                />

                <div className='flex gap-6 flex-col w-2/3 mt-6'>

                    <GoogleOAuthProvider clientId="794991093312-1i2l85tqno28ubs82c7qhcbleptpui8h.apps.googleusercontent.com">

                        <GoogleLogin onLoginSuccess={() => alert('logou')} />

                    </GoogleOAuthProvider>

{/* 
                    <ButtonLoading
                        className="w-1/3 bg-slate-600"
                        loading={false}
                        onClick={editarConfigChatGpt}
                    >
                        Salvar
                    </ButtonLoading> */}
                </div>

            </Container>

        </Box>
    );
}
